<template>
  <div>
    <div class="container-item">
      <div
        class="header"
        :style="{
          'background-image': `url(${require(`assets/images/bg-circle.png`)})`
        }"
      >
        预警趋势
      </div>
      <div class="body">
        <div class="statistic">
          <div class="body">
            <div class="num-statics">
              <div class="title">
                <p class="text">监管企业数量统计</p>
                <p class="sub-text">
                  统计生产企业，流通企业与零售企业参与监管的数量及占比
                </p>
              </div>
              <div class="num-list">
                <div class="num-item">
                  <div class="num indent">{{ productionEntNum }}</div>
                  <div class="text">
                    <span class="ring production"></span>
                    <span>生产企业</span>
                  </div>
                </div>
                <div class="num-item">
                  <div class="num indent">{{ circulateEntNum }}</div>
                  <div class="text">
                    <span class="ring calculate"></span>
                    <span>流通企业</span>
                  </div>
                </div>
                <div class="num-item">
                  <div class="num indent">{{ retailEntNum }}</div>
                  <div class="text">
                    <span class="ring retail"></span>
                    <span>零售企业</span>
                  </div>
                </div>
              </div>
              <Echarts
                :echartsOption="echartsOption1"
                echartsHeight="244px"
                class="echarts1"
              />
            </div>
            <div class="scale-statics">
              <div class="title">
                <p class="text">区域监管进度统计</p>
                <p class="sub-text">
                  区域内部生产企业，流通企业与零售企业参与监管占比
                </p>
              </div>
              <div class="num-list">
                <div class="num-item">
                  <div class="num">{{ monitorRate }}</div>
                  <div class="text">监管进度</div>
                </div>
                <div class="num-item">
                  <div class="num">{{ unMonitorEntNum }}</div>
                  <div class="text">未监管企业数量</div>
                </div>
                <div class="num-item">
                  <div class="num">{{ monitoredEntNum }}</div>
                  <div class="text">已监管企业数量</div>
                </div>
              </div>
              <Echarts :echartsOption="echartsOption2" echartsHeight="244px" />
              <ul class="tab1">
                <li
                  :class="['tab1-item', { active: tab1Filter === 'all' }]"
                  @click="tab1Click('all')"
                >
                  <img
                    :src="
                      tab1Filter === 'all'
                        ? require('assets/images/all_active.png')
                        : require('assets/images/all.png')
                    "
                    alt=""
                    class="tab1-item-img"
                  />
                  <span>全部企业</span>
                </li>
                <li
                  :class="[
                    'tab1-item',
                    { active: tab1Filter === 'production' }
                  ]"
                  @click="tab1Click('production')"
                >
                  <img
                    :src="
                      tab1Filter === 'production'
                        ? require('assets/images/pro_active.png')
                        : require('assets/images/pro.png')
                    "
                    alt=""
                    class="tab1-item-img"
                  />
                  <span>生产企业</span>
                </li>
                <li
                  :class="['tab1-item', { active: tab1Filter === 'circulate' }]"
                  @click="tab1Click('circulate')"
                >
                  <img
                    :src="
                      tab1Filter === 'circulate'
                        ? require('assets/images/cir_active.png')
                        : require('assets/images/cir.png')
                    "
                    class="tab1-item-img"
                    alt=""
                  />
                  <span>流通企业</span>
                </li>
                <li
                  :class="['tab1-item', { active: tab1Filter === 'retail' }]"
                  @click="tab1Click('retail')"
                >
                  <img
                    :src="
                      tab1Filter === 'retail'
                        ? require('assets/images/retail_active.png')
                        : require('assets/images/retail.png')
                    "
                    class="tab1-item-img"
                    alt=""
                  />
                  <span>零售企业</span>
                </li>
              </ul>
            </div>
            <div class="border"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-item">
      <div
        class="header"
        :style="{
          'background-image': `url(${require(`assets/images/bg-squre.png`)})`
        }"
      >
        监管数据数量统计
      </div>
      <div class="body">
        <div class="search">
          <el-form label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="时间范围">
                  <el-date-picker
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-button
                  type="primary"
                  style="margin-left: 30px"
                  @click="loadEcharts3Data"
                  >查询</el-button
                >
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="0px">
                  <el-switch
                    v-model="switchValue"
                    active-color="#386CE2"
                    inactive-color="#386CE2"
                    active-value="0"
                    inactive-value="1"
                    active-text="文档"
                    inactive-text="数据"
                    @change="loadEcharts3Data"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <echarts :echartsOption="echartsOption3" echartsHeight="377px" />
      </div>
    </div>
    <div class="container-item">
      <div
        class="header"
        :style="{
          'background-image': `url(${require(`assets/images/bg-rectangle.png`)})`
        }"
      >
        药品流通概况
      </div>
      <div class="body">
        <div class="statistic">
          <div class="body">
            <div class="num-statics">
              <div class="title">
                <p class="text">国内省份流向关联度</p>
                <p class="sub-text">
                  按照原辅料流入，药品注入与药品转化数据关联程度统计
                </p>
              </div>
              <Echarts
                :echartsOption="echartsOption4"
                echartsHeight="277px"
                style="margin-top: 20px"
              />
            </div>
            <div class="scale-statics">
              <div class="title">
                <p class="text">原辅料流入统计</p>
                <p class="sub-text">
                  原辅料名称数量
                </p>
              </div>
              <div class="num-list">
                <div class="num-item">
                  <div class="num">{{ rawAccessorySupplierNum }}</div>
                  <div class="text">供应商数量</div>
                </div>
                <div class="num-item">
                  <div class="num">{{ rawAccessoryMaterielNum }}</div>
                  <div class="text">原辅料名称数量</div>
                </div>
                <div class="num-item">
                  <div class="num">{{ rawAccessoryProvinceNum }}</div>
                  <div class="text">来源省份数量</div>
                </div>
              </div>
              <Echarts :echartsOption="echartsOption5" />
            </div>
            <div class="num-statics">
              <div class="title">
                <p class="text">药品流入统计</p>
                <p class="sub-text">
                  药品批准文号数量
                </p>
              </div>
              <div class="num-list">
                <div class="num-item">
                  <div class="num">{{ drugInEntNum }}</div>
                  <div class="text">生产企业数量</div>
                </div>
                <div class="num-item">
                  <div class="num">{{ drugInApprovalNum }}</div>
                  <div class="text">药品批准文号数量</div>
                </div>
                <div class="num-item">
                  <div class="num">{{ drugInProvinceNum }}</div>
                  <div class="text">来源省份数量</div>
                </div>
              </div>
              <Echarts :echartsOption="drugInOption" />
            </div>
            <div class="scale-statics">
              <div class="title">
                <p class="text">药品流出统计</p>
                <p class="sub-text">
                  药品批准文号数量
                </p>
              </div>
              <div class="num-list">
                <div class="num-item">
                  <div class="num">{{ drugOutEntNum }}</div>
                  <div class="text">生产企业数量</div>
                </div>
                <div class="num-item">
                  <div class="num">{{ drugOutApprovalNum }}</div>
                  <div class="text">药品批准文号数量</div>
                </div>
                <div class="num-item">
                  <div class="num">{{ drugOutProvinceNum }}</div>
                  <div class="text">去向省份数量</div>
                </div>
              </div>
              <Echarts :echartsOption="drugOutOption" />
            </div>
            <div class="border"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
import 'echarts/map/js/province/neimenggu';
import 'echarts/map/js/china';

const switchValueMap = {
  '1': ['生产企业', '流通企业', '零售企业'],
  '0': ['原辅料检验报告', '成品检验报告', '省检院报告', '零售票据']
};
const colors = ['#FFB439', '#2BBF99', '#386CE2', '#CEDBEF'];
export default {
  data() {
    return {
      productionEntNum: '',
      circulateEntNum: '',
      retailEntNum: '',
      echartsOption1: {
        backgroundColor: '#fff',
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: params => {
            return `${params.seriesName}<br/>${params.name}:${params.value}(${(
              (params.percent * 4) /
              3
            ).toFixed(2)}%)`;
          }
        },
        color: ['#FF8700', '#ffc300', '#00e473', '#009DFF'],
        grid: {
          top: '3%',
          bottom: '74.5%',
          left: '60%',
          containLabel: false
        },
        yAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: []
        },
        xAxis: {
          show: false
        },
        series: []
      },
      monitorRate: '',
      unMonitorEntNum: '',
      monitoredEntNum: '',
      tab1Filter: 'all',
      echartsOption2: {
        tooltip: {
          show: true,
          formatter: params => {
            if (params.data) {
              return `${params.name}</br>${params.marker}监管企业数量：${params.data.checkNum}</br>${params.marker}监管进度：${params.data.value}%`;
            } else {
            }
          }
        },
        visualMap: {
          type: 'continuous',
          text: ['高', '低'],
          showLabel: true,
          seriesIndex: [0],
          min: 0,
          itemWidth: '7px',
          itemHeight: '60px',
          max: '',
          inRange: {
            color: ['#f7fbff', '#4e7cef', '#0549f3']
          },
          textStyle: {
            color: '#000'
          },
          bottom: '-5',
          left: '90px'
        },
        geo: {
          roam: true,
          map: '内蒙古',
          layoutCenter: ['50%', '50%'],
          layoutSize: '100%',
          label: {
            emphasis: {
              show: false
            }
          },
          scaleLimit: {
            min: 1.2,
            max: 10
          },
          itemStyle: {
            emphasis: {
              areaColor: '#fff464'
            }
          }
        },
        series: [
          {
            name: 'mapSer',
            type: 'map',
            roam: false,
            geoIndex: 0,
            label: {
              show: false
            },
            data: []
          }
        ]
      },
      time: '',
      echartsOption3: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: [],
          bottom: '30px',
          textStyle: {
            color: '#666666'
          }
        },
        grid: {
          top: '20px',
          left: '3%',
          right: '4%',
          bottom: '70px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLabel: {
              color: '#999999'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLabel: {
              color: '#999999'
            }
          }
        ],
        series: []
      },
      echartsOption4: {
        tooltip: {
          show: false
        },
        visualMap: {
          type: 'continuous',
          text: ['高', '低'],
          showLabel: true,
          seriesIndex: [0],
          min: 0,
          itemWidth: '7px',
          itemHeight: '60px',
          max: '',
          inRange: {
            color: ['#f7fbff', '#4e7cef', '#0549f3']
          },
          textStyle: {
            color: '#000'
          },
          bottom: '-5',
          left: '90px'
        },
        geo: {
          roam: true,
          map: 'china',
          layoutCenter: ['50%', '50%'],
          layoutSize: '100%',
          label: {
            emphasis: {
              show: false
            }
          },
          scaleLimit: {
            min: 1.2,
            max: 10
          },
          itemStyle: {
            emphasis: {
              show: false,
              areaColor: '#000'
            }
          },
          silent: true
        },
        series: [
          {
            name: 'mapSer',
            type: 'map',
            roam: false,
            geoIndex: 0,
            label: {
              show: false
            },
            data: []
          }
        ]
      },
      rawAccessorySupplierNum: '',
      rawAccessoryMaterielNum: '',
      rawAccessoryProvinceNum: '',
      echartsOption5: {
        grid: {
          top: '26px'
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424',
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        series: [
          {
            data: [],
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            }
          }
        ]
      },
      drugInEntNum: '',
      drugInApprovalNum: '',
      drugInProvinceNum: '',
      drugInOption: {
        grid: {
          top: '26px'
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424',
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        series: [
          {
            data: [],
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            }
          }
        ]
      },
      drugOutEntNum: '',
      drugOutApprovalNum: '',
      drugOutProvinceNum: '',
      drugOutOption: {
        grid: {
          top: '26px'
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424',
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#CEDBEF'
            }
          },
          axisLabel: {
            color: '#242424'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        series: [
          {
            data: [],
            type: 'bar',
            barWidth: '8px',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#5140C6' },
                { offset: 0, color: '#386CE2' }
              ])
            }
          }
        ]
      },
      switchValue: '1'
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadEcharts1Data();
      this.loadEcharts2Data();
      this.loadEcharts3Data();
      this.loadEcharts4Data();
      this.loadEcharts5Data();
      this.loadDrugEcharts('In');
      this.loadDrugEcharts('Out');
    },
    loadEcharts1Data() {
      this.$request({
        url: 'open/entStatics/entCountStatics'
      }).then(res => {
        const data = [
          {
            value: res[0].scNum,
            name: '生产企业数量',
            total: res[0].totalScNum
          },
          {
            value: res[0].ltNum,
            name: '流通企业数量',
            total: res[0].totalLtNum
          },
          {
            value: res[0].lsNum,
            name: '零售企业数量',
            total: res[0].totalLsNum
          }
        ];
        const result = this.dealHalfPieData(data);
        this.echartsOption1.series = result.series;
        this.echartsOption1.yAxis.data = result.yAxis.reverse();
        this.productionEntNum = res[0].scNum;
        this.circulateEntNum = res[0].ltNum;
        this.retailEntNum = res[0].lsNum;
      });
    },
    loadEcharts2Data(entType) {
      this.$request({
        url: 'rest/entStatics/entAreaStatics',
        data: {
          json: JSON.stringify({
            params: {
              entType: this.$common.entType[entType] || ''
            }
          })
        }
      }).then(res => {
        this.monitorRate = res.allDataRate;
        this.unMonitorEntNum = res.allNum - res.checkNum;
        this.monitoredEntNum = res.checkNum;
        const data = res.dataList.map(item => ({
          ...item,
          name: item.cityName,
          value: parseFloat(item.dataRate)
        }));
        const max = Math.max(
          ...res.dataList.map(item => parseFloat(item.dataRate))
        );
        this.echartsOption2.series[0].data = data;
        this.echartsOption2.visualMap.max = max;
      });
    },
    loadEcharts3Data() {
      this.$request({
        url: 'rest/dataWeekControl/queryWeekDataList',
        data: {
          json: JSON.stringify({
            params: {
              dataType: this.switchValue,
              endDate: this.time ? this.time[1] : '',
              startDate: this.time ? this.time[0] : ''
            }
          })
        }
      }).then(res => {
        const series = [];
        const seriesLength = Object.keys(res).length;
        const legendData = switchValueMap[this.switchValue];
        let xAxisData = [];
        for (let i = 0; i < seriesLength; i++) {
          series.push({
            name: legendData[i],
            type: 'line',
            stack: '总量',
            lineStyle: {
              color: colors[i]
            },
            itemStyle: {
              color: colors[i]
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: colors[i]
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: []
          });
        }
        if (this.switchValue === '1') {
          xAxisData = res.lsList.map(item => item.weekEndDateSource);
          series[0].data = res.scList.map(item => item.dataNum);
          series[1].data = res.ltList.map(item => item.dataNum);
          series[2].data = res.lsList.map(item => item.dataNum);
        } else {
          xAxisData = res.materialsReport.map(item => item.weekEndDateSource);
          series[0].data = res.materialsReport.map(item => item.reportNum);
          series[1].data = res.productReport.map(item => item.reportNum);
          series[2].data = res.provinceProductReport.map(
            item => item.reportNum
          );
          series[3].data = res.ticket.map(item => item.reportNum);
        }
        this.echartsOption3.legend.data = legendData;
        this.echartsOption3.xAxis[0].data = xAxisData;
        this.echartsOption3.series = series;
      });
    },
    loadEcharts4Data() {
      this.$request({
        url: 'rest/entStatics/provinceFlowCorrelation'
      }).then(res => {
        this.echartsOption4.visualMap.max = Math.max(
          ...res.map(item => item.num)
        );
        this.echartsOption4.series[0].data = res.map(item => {
          if (item.provinceName === '黑龙江省') {
            return {
              value: item.num,
              name: '黑龙江'
            };
          } else if (item.provinceName === '内蒙古自治区') {
            return {
              value: item.num,
              name: '内蒙古'
            };
          } else {
            return {
              name: item.provinceName.substring(0, 2),
              value: item.num
            };
          }
        });
      });
    },
    // 原辅料流入图表
    loadEcharts5Data() {
      this.$request({
        url: 'rest/circulation/supplierAreaStatics',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 10000
            },
            params: {
              materielName: '',
              regionCode: ''
            }
          })
        }
      }).then(res => {
        this.rawAccessorySupplierNum = res.supplierNum;
        this.rawAccessoryMaterielNum = res.materielNum;
        this.rawAccessoryProvinceNum = res.provinceNum;
        const xData = [];
        const yData = [];
        res.list.forEach(item => {
          xData.push(item.short_name);
          yData.push(item.materiel_num);
        });
        this.echartsOption5.xAxis.data = xData;
        this.echartsOption5.series[0].data = yData;
      });
    },
    // 药品流入/流出图表
    loadDrugEcharts(type) {
      const params = {
        approvalNumber: '',
        productName: '',
        regionCode: '',
        tableName:
          type === 'In' ? 'buss_drug_income_info' : 'buss_drug_out_info'
      };
      this.$request({
        url: 'rest/circulation/bussOutInStatics',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 10000
            },
            params
          })
        }
      }).then(res => {
        this[`drug${type}ApprovalNum`] = res.approvalNum;
        this[`drug${type}EntNum`] = res.entNum;
        this[`drug${type}ProvinceNum`] = res.provinceNum;
        const xData = [];
        const yData = [];
        res.list.forEach(item => {
          xData.push(item.short_name);
          yData.push(item.approval_number);
        });
        this[`drug${type}Option`].xAxis.data = xData;
        this[`drug${type}Option`].series[0].data = yData;
      });
    },
    tab1Click(type) {
      this.tab1Filter = type;
      this.loadEcharts2Data(type);
    },
    dealHalfPieData(data) {
      const seriesName = '监管企业数量';
      const maxRadius = 98;
      const nextRadiusGap = 12;
      const minRadiusGap = 10;
      const bgColor = '#E3F0FF'; // 占位环的颜色
      const pieCenter = ['50%', '50%']; // 圆环中心
      const bgColors = ['#386CE2', '#FFB439', '#2BBF99']; // 环的颜色
      const result = {
        series: [],
        yAxis: []
      };
      for (let i = 0; i < data.length; i++) {
        result.series.push({
          name: seriesName,
          type: 'pie',
          clockWise: false, // 顺时加载
          hoverAnimation: false, // 鼠标移入变大
          radius: [
            `${maxRadius - i * (nextRadiusGap + minRadiusGap)}%`,
            `${maxRadius - i * (nextRadiusGap + minRadiusGap) - 10}%`
          ],
          center: pieCenter,
          label: {
            show: false
          },
          itemStyle: {
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            borderWidth: 5
          },
          data: [
            {
              value: data[i].value,
              name: data[i].name,
              itemStyle: {
                color: bgColors[i]
              }
            },
            {
              value:
                parseInt(data[i].total) === 0
                  ? 1
                  : (data[i].total * 4) / 3 - data[i].value,
              name: '',
              itemStyle: {
                color: 'rgba(0,0,0,0)',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }
          ]
        });
        result.series.push({
          name: '',
          type: 'pie',
          clockWise: false, // 顺时加载
          hoverAnimation: false, // 鼠标移入变大
          radius: [
            `${maxRadius - i * (nextRadiusGap + minRadiusGap)}%`,
            `${maxRadius - i * (nextRadiusGap + minRadiusGap) - 10}%`
          ],
          center: pieCenter,
          z: 1,
          label: {
            show: false
          },
          itemStyle: {
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            borderWidth: 5
          },
          data: [
            {
              value: 7.5,
              itemStyle: {
                color: bgColor,
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            },
            {
              value: 2.5,
              name: '',
              itemStyle: {
                color: 'rgba(0,0,0,0)',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }
          ]
        });
        if (parseInt(data[i].total) === 0) {
          result.yAxis.push('0.00%');
        } else {
          result.yAxis.push(
            ((data[i].value / data[i].total) * 100).toFixed(2) + '%'
          );
        }
      }
      return result;
    }
  },
  components: {
    Echarts
  }
};
</script>

<style lang="stylus" scoped>
.container-item
  margin-bottom 21px
  .header
    background-size cover
    height 74px
    line-height 60px
    padding-left 21px
    font-size 18px
    border-radius 8px 8px 0 0
    color #fff
  >.body
    position relative
    background #fff
    border-radius 8px
    transform translate(0, -16px)
    overflow hidden
    padding 0 20px
    .statistic
      margin-top 20px
      padding 0 20px
      background #fff
      border-radius 8px
      overflow hidden
      color #000
      .body
        position relative
        overflow hidden
        padding-bottom 30px
        .num-statics
          position relative
          width 50%
          float left
          .echarts-border
            position absolute
            width 1px
            background rgba(206,219,239,.5)
            left 504px
            top 190px
            height 320px
          .echarts1
            margin-bottom 58px
        .scale-statics
          width 50%
          float left
          .title
            padding-left 30px
        .border
          width 1px
          position absolute
          top 0
          left 50%
          bottom 0
          background rgba(206,219,239,.5)
        .title
          border-bottom 1px solid #CEDBEF
          border-top 1px solid #CEDBEF
          padding 5px 0
          .text
            font-size 14px
            margin-bottom 5px
          .sub-text
            font-size 12px
            color #666666
        .num-list
          display flex
          justify-content center
          height 80px
          align-items center
          .num-item
            margin 0 20px
            text-align center
            .num
              color #386CE2
              font-size 28px
              &.indent
                text-indent 25px
            .text
              font-size 12px
              display flex
              align-items center
              justify-content center
              .ring
                display inline-block
                width 12px
                height 12px
                border-width 1px
                border-style solid
                border-radius 50%
                margin-right 13px
                position relative
                &:after
                  content ' '
                  display inline-block
                  width 8px
                  height 8px
                  position absolute
                  left 2px
                  top 2px
                  border-radius 50%
                &.production
                  border-color #386CE2
                  &:after
                    background #386CE2
                &.calculate
                  border-color #FFB439
                  &:after
                    background #FFB439
                &.retail
                  border-color #2BBF99
                  &:after
                    background #2BBF99
      .tab1
          line-height 48px
          display flex
          margin-top 14px
          font-size 12px
          justify-content center
          .tab1-item
            display flex
            align-items center
            cursor pointer
            margin 0 24px
            &.active
              color #386ce2
            .tab1-item-img
              width 14px
              margin-right 10px
    .search
      margin 20px 0
>>>.el-switch__label.is-active
  color #386CE2 !important
</style>
